/* ArtMindr — съобщението от Иван по време на чакането (стъпка 5).

   Как работи:
   - Видеото няма src, докато не дойде моментът. При зареждане на страницата: 0 байта.
   - След N секунди чакане заглавието горе става „Имаш съобщение от Иван" и видеото
     се появява под лентата и тръгва САМО — без натискане.
   - Звукът: браузърите не пускат звук без разрешение. Първо опитваме СЪС звук; ако
     браузърът откаже (почти винаги на iPhone), тръгва беззвучно и излиза голямо копче
     „Пусни звука", което го връща в началото със звук.
   - Ако корицата стане готова, докато видеото върви, го спираме — иначе гласът щеше да
     продължи върху екрана с корицата.
*/
(function(){
  'use strict';
  var box = document.querySelector('[data-amf-msg]');
  if(!box) return;
  var src = box.getAttribute('data-src');
  if(!src) return;

  var vid    = box.querySelector('[data-amf-msg-vid]');
  var unmute = box.querySelector('[data-amf-msg-unmute]');
  if(!vid) return;

  var delay = parseInt(box.getAttribute('data-delay'), 10);
  if(isNaN(delay) || delay < 0) delay = 18;
  var head = box.getAttribute('data-head') || 'Имаш съобщение от Иван';

  function step(n){
    var el = document.querySelector('[data-amf-step="' + n + '"]');
    return !!(el && el.classList.contains('is-active'));
  }

  /* --- смяна на заглавието горе --- */
  var h = document.querySelector('[data-amf-step="5"] .amf__h');
  var savedHTML = null;
  function swapHead(){
    if(!h || savedHTML !== null) return;
    savedHTML = h.innerHTML;
    h.textContent = head;
  }
  function restoreHead(){
    if(!h || savedHTML === null) return;
    h.innerHTML = savedHTML;
    savedHTML = null;
  }

  /* --- пускане --- */
  var started = false;
  function start(){
    if(started) return;
    started = true;
    swapHead();
    box.hidden = false;
    vid.setAttribute('src', src);
    try { vid.load(); } catch(e){}

    // първо опитваме със звук
    vid.muted = false;
    var p = vid.play();
    if(p && p.catch){
      p.catch(function(){
        // браузърът отказа звука — тръгваме беззвучно и питаме
        vid.muted = true;
        var q = vid.play();
        if(q && q.catch) q.catch(function(){});
        if(unmute) unmute.hidden = false;
      });
    }
    if(window.amfTrack) window.amfTrack('founder_message_start', {});
  }

  if(unmute){
    unmute.addEventListener('click', function(){
      unmute.hidden = true;
      vid.muted = false;
      try { vid.currentTime = 0; } catch(e){}
      var p = vid.play();
      if(p && p.catch) p.catch(function(){});
      if(window.amfTrack) window.amfTrack('founder_message_unmute', {});
    });
  }

  vid.addEventListener('ended', function(){
    if(unmute) unmute.hidden = true;
    restoreHead();
    box.hidden = true;
    if(window.amfTrack) window.amfTrack('founder_message_end', {});
  });

  /* --- броенето до появата, само докато сме на стъпка 5 --- */
  var since = 0;
  var tick = setInterval(function(){
    if(started){ clearInterval(tick); return; }
    if(!step(5)){ since = 0; return; }
    since++;
    if(since >= delay) start();
  }, 1000);

  /* --- корицата е готова: спираме гласа --- */
  var watch = setInterval(function(){
    if(!step(6)) return;
    try { vid.pause(); } catch(e){}
    if(unmute) unmute.hidden = true;
    box.hidden = true;
    clearInterval(watch);
    if(tick) clearInterval(tick);
  }, 1000);

  /* скрит таб — не говорим на празно */
  document.addEventListener('visibilitychange', function(){
    if(document.hidden){ try { vid.pause(); } catch(e){} }
  });
})();
